import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../services/faq.service';
import {ActivatedRoute} from '@angular/router';
import {FaqArticle} from '../../model/faq-article';

import {FaqArticleDisplayComponent} from "../../components/common/faq-article-display/faq-article-display.component";

@Component({
    selector: 'app-publicfaq',
    imports: [
    FaqArticleDisplayComponent
],
    templateUrl: './publicfaq.component.html',
    styleUrls: ['./publicfaq.component.css']
})
export class PublicfaqComponent implements OnInit {

  article: FaqArticle;

  constructor(private faqService: FaqService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.faqService.getObjects().subscribe(articles => {
      this.article = articles.find(a => a.id === +id);
    });
  }

}
